export const isScored = (point) => point?.score !== null && point?.score !== undefined

export const shownPoint = (entry) => (isScored(entry.latest) ? entry.latest : entry.lastScored || null)

export const cardModel = (entry) => {
  const shown = shownPoint(entry)
  return (shown ? shown.model : entry.latest.model) ?? null
}

export const hasScoredReport = (data) => Boolean(data?.bureaus?.some((entry) => entry.points.some(isScored)))

export const hasUnreportedModel = (bureaus) => bureaus.some((entry) => (
  entry.points.some((point) => isScored(point) && (point.model === null || point.model === undefined))
))
